module.exports = __webpack_public_path__ + "img/Delete (1).50eb7dec.svg";